// Port of api/fuel/app/classes/filter/advanced/collection.php
// Detects "ownership leakage" in advanced rule trees.

function isOwnNumericType(type) {
	return type === 'collection.own' || type === 'model.collection_own' || type === 'own'
}

function isOwnStatusType(type) {
	return type === 'collection.status' || type === 'collection_status'
}

function toStringArray(v) {
	if (v === null || v === undefined) return []
	if (Array.isArray(v)) return v.map(function(x) { return String(x) })
	return [String(v)]
}

function scalarVal(v) {
	if (Array.isArray(v)) return v[0]
	return v
}

function enforcesOwn1Numeric(op, val) {
	if (op === '=' || op === '==' || op === 'eq') {
		return parseInt(scalarVal(val), 10) === 1
	}
	if (op === 'in' && Array.isArray(val)) {
		return val.length === 1 && parseInt(val[0], 10) === 1
	}
	return false
}

function hasAnyNonOwnedStatus(vals) {
	var nonOwned = ['prevowned', 'previouslyowned', 'want', 'wanted', 'wishlist', 'trade', 'fortrade', 'preordered', 'preorder', 'none', 'notowned']
	vals = vals.map(function(v) { return v.toLowerCase() })
	for (var i = 0; i < vals.length; i++) {
		if (nonOwned.indexOf(vals[i]) !== -1) return true
	}
	return false
}

function analyzeRule(rule) {
	var type = String(rule.type || '').toLowerCase()
	var logic = rule.logic || {}
	var op = String(logic.operand || '=').toLowerCase()
	var val = logic.value

	if (isOwnNumericType(type)) {
		var enforces = enforcesOwn1Numeric(op, val)
		return { mentions: true, guarantees: enforces, leaks: !enforces }
	}

	if (isOwnStatusType(type)) {
		var vals = toStringArray(val)
		var enforces2 = false
		if (['=', '==', 'eq', 'in'].indexOf(op) !== -1) {
			enforces2 = (vals.length === 1 && vals[0] === 'own')
		}
		return { mentions: true, guarantees: enforces2, leaks: !enforces2 }
	}

	return { mentions: false, guarantees: false, leaks: false }
}

function analyzeGroup(group) {
	var join = String(group.logic || 'and').toLowerCase()
	var children = group.rules || []

	var parts = []
	for (var i = 0; i < children.length; i++) {
		var child = children[i]
		if (child.rules && Array.isArray(child.rules)) {
			parts.push(analyzeGroup(child))
		} else if (child.rule) {
			parts.push(analyzeRule(child.rule))
		} else {
			parts.push({ mentions: false, guarantees: false, leaks: false })
		}
	}

	var mentions = false
	for (var m = 0; m < parts.length; m++) {
		if (parts[m].mentions) { mentions = true; break }
	}

	if (join === 'and') {
		var guarantees = false
		for (var g = 0; g < parts.length; g++) {
			if (parts[g].guarantees) { guarantees = true; break }
		}
		return { mentions: mentions, guarantees: guarantees, leaks: mentions && !guarantees }
	} else if (join === 'or') {
		var allGuarantee = parts.length > 0
		var anyNotGuaranteed = false
		for (var a = 0; a < parts.length; a++) {
			if (!parts[a].guarantees) { allGuarantee = false; anyNotGuaranteed = true; break }
		}
		return { mentions: mentions, guarantees: allGuarantee, leaks: mentions && anyNotGuaranteed }
	} else {
		return { mentions: mentions, guarantees: false, leaks: mentions }
	}
}

function classify(node) {
	// Leaf rule
	if (node.rule) {
		var rule = node.rule
		var type = String(rule.type || '').toLowerCase()
		var logic = rule.logic || {}
		var op = String(logic.operand || '=').toLowerCase()
		var val = logic.value

		if (isOwnNumericType(type)) {
			return enforcesOwn1Numeric(op, val) ? 'owned_only' : 'leaky'
		}
		if (isOwnStatusType(type)) {
			var vals = toStringArray(val)
			if (hasAnyNonOwnedStatus(vals)) return 'leaky'
			if (['=', '==', 'eq', 'in'].indexOf(op) !== -1 && vals.length === 1 && vals[0] === 'own') {
				return 'owned_only'
			}
			return 'neutral'
		}
		return 'neutral'
	}

	// Group
	var groupLogic = String(node.logic || 'and').toLowerCase()
	var rules = node.rules || []
	if (!rules.length) return 'neutral'

	var childClasses = rules.map(classify)

	if (childClasses.indexOf('leaky') !== -1) return 'leaky'

	if (groupLogic === 'and') {
		return childClasses.indexOf('owned_only') !== -1 ? 'owned_only' : 'neutral'
	}
	if (groupLogic === 'or') {
		var unique = []
		for (var i = 0; i < childClasses.length; i++) {
			if (unique.indexOf(childClasses[i]) === -1) unique.push(childClasses[i])
		}
		return (unique.length === 1 && unique[0] === 'owned_only') ? 'owned_only' : 'neutral'
	}

	return 'neutral'
}

function collectOwnScopes(node, acc) {
	if (!node.rules || !Array.isArray(node.rules)) return

	var logic = String(node.logic || 'and').toLowerCase()
	var rules = node.rules

	var classes = []
	for (var i = 0; i < rules.length; i++) {
		classes.push(classify(rules[i]))
	}

	// If this is an OR with at least one leaky child, mark each NEUTRAL child
	if (logic === 'or' && classes.indexOf('leaky') !== -1) {
		for (var j = 0; j < rules.length; j++) {
			if (classes[j] === 'neutral') {
				var id = String(rules[j].id || '')
				if (id !== '') acc[id] = true
			}
		}
	}

	// Recurse
	for (var k = 0; k < rules.length; k++) {
		collectOwnScopes(rules[k], acc)
	}
}

export default {
	fails: function(filter) {
		if (!filter || !filter.logic) return false
		var res = analyzeGroup(filter)
		return res.leaks
	},

	idsRequiringOwn: function(node) {
		var acc = {}
		if (node) collectOwnScopes(node, acc)
		return acc
	}
}
